<template>
  <div class="profile-widget" :class="calcStyles">
    <div v-if="(rows > 1) && id"
      class="profile-avatar"
    >
      <div class="profile-avatar-text"><span>{{nameInitials(title)}}</span></div>
      <img v-if="imgUrl" :src="imgUrl" alt="" onerror="this.style.display='none'" 
        class="profile-avatar-img"
      />
    </div>
    <div class="profile-widget-content">
      <div class="profile-widget-core">
        <span class="profile-widget-title">{{title}}</span>
        <span v-if="showSubtitle" class="profile-widget-subtitle">{{subtitle}}</span>
      </div>
      <ProfileFields :fields="fields" v-if="fields" />
    </div>
  </div>
</template>

<script>
/* Simple template that formats whatever you give it. */
import {nameInitials} from '@/utils/Attendee';
import ProfileFields from './ProfileFields';

export default {
  name: "ProfileWidget",
  props: {
    title: String,
    subtitle: String,
    id: {
      type: Number,
      required: false,
    },
    rows: {
      type: Number,
      default: 1,
      required: false,
    },
    fields: {
      type: Array,
      default: null,
      required: false,
    },
    hint: String, // Deprecated?
    url: String, // Deprecated? - wrap widget if needed
  },
  components: {
    ProfileFields,
  },
  methods: {
    nameInitials,
  },
  computed: {
      showSubtitle() {
        if (!this.subtitle) { return false;}
        if (this.subtitle == this.title) { return false; }
        return true;
      },
      imgUrl() {
          if (this.id) { return "/api/v2/img/profile/"+this.id; }
          return false;
      },
      calcStyles() {
        let styles = []
        if (this.rows == 2) {
          return 'profile-double';
        }
        if (this.rows == 3) {
          return 'profile-triple';
        }

        
        if (this.style) {
          if (this.style.indexOf('double') > -1) { styles.append('profile-widget-double'); }
          if (this.style.indexOf('triple') > -1) { styles.append('profile-widget-triple'); }
          return styles;
        }
        return null;
      },
  },
};
</script>

<style>
/* SHARED CSS */
.profile-cols-1,
.profile-cols-2,
.profile-cols-3,
.profile-cols-4,
.profile-cols-5,
.profile-cols-6 {
  display: grid;
  gap: 10px;
  
}
.profile-cols-1 .profile-widget,
.profile-cols-2 .profile-widget,
.profile-cols-3 .profile-widget,
.profile-cols-4 .profile-widget,
.profile-cols-5 .profile-widget,
.profile-cols-6 .profile-widget {
  xdisplay: block;
  xflex-grow: 1;
}
.profile-cols-1 {
  grid-template-columns: repeat(1, 1fr);
}
.profile-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}
.profile-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}
.profile-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}
.profile-cols-5 {
  grid-template-columns: repeat(5, 1fr);
}
.profile-cols-6 {
  grid-template-columns: repeat(6, 1fr);
}


.profile-widget {
  display: block; /* inline- */
  border-radius: 3px;
  padding: 0 5px 0 0;
}


.profile-widget small {
  display: inline-block;
  margin-left: 5px;
  color: #333;
}
a.profile-widget:hover {
  background: #ddf;
}
a.profile-widget:hover small {
  text-decoration: none;
}

.profile-avatar {
  position: relative;
  margin-right: 10px;
}
.profile-double .profile-avatar {
  height: 38px; /* 20px +15px +3px spare */
  width: 38px;
  min-width: 38px;
}
.profile-triple .profile-avatar {
  height: 53px; /* 20px +15px +15px +3px spare */
  width: 53px;
  min-width: 53px;
}

.profile-avatar-text {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #666;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
.profile-avatar-img {
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.profile-widget-content {
  flex-grow: 1;
}
.profile-widget-title {
  padding-right: 1ch;
}
.profile-widget-subtitle {
  font-style: italic;
}
/*
.profile-widget-subtitle::before {
  content: "(";
}
.profile-widget-subtitle::after {
  content: ")";
}
*/

.profile-block {
  display: block;
  margin-bottom: 5px;
}

.profile-block {
  display: block;
  margin-bottom: 5px;
}

.profile-double,
.profile-triple{
  display: inline-flex;
}
.profile-block.profile-double,
.profile-block.profile-triple {
  display: flex;
}
/* .profile-double img {
    max-height: 38px; /* 20px +15px +3px spare * /
    max-width: 38px;
    margin-right: 10px;
} */
.profile-double .profile-widget-title {
    display: block;
    font-weight: bold;
}
.profile-double small,
.profile-triple small {
  display: block;
  margin-left: 0;
  line-height: 15px;
}
a.profile-double:hover,
a.profile-triple:hover {
  text-decoration: none;
}

/* .profile-triple img {
    max-height: 53px; /* 20px +15px +15px +3px spare * /
    max-width: 53px;
} */
</style>